module.exports = __webpack_public_path__ + "static/media/CF_WebIcons_SpouseProgram_Do.82cdee63.svg";